import { __extends, __rest, __assign } from 'tslib';
import { createElement, Component, Children } from 'react';
import { classNames } from 'uitk-react-utils';

var UitkMessagingCardImageLayout;
(function (UitkMessagingCardImageLayout) {
    UitkMessagingCardImageLayout["LEFT"] = "imagelayout-left";
})(UitkMessagingCardImageLayout || (UitkMessagingCardImageLayout = {}));
var UitkMessagingCard = /** @class */ (function (_super) {
    __extends(UitkMessagingCard, _super);
    function UitkMessagingCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMessagingCard.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, imageLayout = _a.imageLayout, withBorder = _a.withBorder, attributes = __rest(_a, ["children", "className", "imageLayout", "withBorder"]);
        var cssClassNames = classNames('uitk-messaging-card', className, imageLayout, {
            'uitk-messaging-card-empty': children === undefined,
            'uitk-messaging-card-with-border': withBorder
        });
        return (createElement("div", __assign({ className: cssClassNames }, attributes), children));
    };
    UitkMessagingCard.displayName = 'UitkMessagingCard';
    return UitkMessagingCard;
}(Component));

var UitkMessagingCardMedia = /** @class */ (function (_super) {
    __extends(UitkMessagingCardMedia, _super);
    function UitkMessagingCardMedia() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMessagingCardMedia.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, withBackground = _a.withBackground, attributes = __rest(_a, ["children", "className", "withBackground"]);
        var cssClassNames = classNames('uitk-messaging-card-media', className, {
            'uitk-messaging-card-media-background': withBackground
        });
        return (createElement("div", __assign({ className: cssClassNames }, attributes), children));
    };
    UitkMessagingCardMedia.displayName = 'UitkMessagingCardMedia';
    return UitkMessagingCardMedia;
}(Component));

var UitkMessagingCardSection = /** @class */ (function (_super) {
    __extends(UitkMessagingCardSection, _super);
    function UitkMessagingCardSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMessagingCardSection.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, heading = _a.heading, headingLevel = _a.headingLevel, attributes = __rest(_a, ["children", "className", "heading", "headingLevel"]);
        var cssClassNames = classNames(className, UitkMessagingCardSection.baseClassName);
        var HeaderTag = createElement(headingLevel || UitkMessagingCardSection.defaultProps.headingLevel, { className: UitkMessagingCardSection.baseClassName + "-header" }, heading);
        return (createElement("section", __assign({ className: cssClassNames }, attributes),
            heading && HeaderTag,
            children));
    };
    UitkMessagingCardSection.displayName = 'UitkMessagingCardSection';
    UitkMessagingCardSection.defaultProps = {
        heading: '',
        headingLevel: 'h3'
    };
    UitkMessagingCardSection.baseClassName = 'uitk-messaging-card-section';
    return UitkMessagingCardSection;
}(Component));

var UitkMessagingCardActionArea = /** @class */ (function (_super) {
    __extends(UitkMessagingCardActionArea, _super);
    function UitkMessagingCardActionArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMessagingCardActionArea.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children;
        var childCount = Children.toArray(children).length;
        var cssClassNames = classNames(className, UitkMessagingCardActionArea.baseClassName);
        return childCount > 0 ? createElement("div", { className: cssClassNames }, children) : null;
    };
    UitkMessagingCardActionArea.displayName = 'UitkMessagingCardActionArea';
    UitkMessagingCardActionArea.baseClassName = 'uitk-messaging-card-action-area';
    return UitkMessagingCardActionArea;
}(Component));

export { UitkMessagingCard, UitkMessagingCardActionArea, UitkMessagingCardImageLayout, UitkMessagingCardMedia, UitkMessagingCardSection };
